"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
exports.destroy = destroy;
exports.getContext = getContext;

var _eth2BlsWasm = _interopRequireDefault(require("@chainsafe/eth2-bls-wasm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable require-atomic-updates */
let blsWrapper = null;

async function init() {
  if (blsWrapper) return blsWrapper;
  await _eth2BlsWasm.default.init();
  blsWrapper = _eth2BlsWasm.default;
  return blsWrapper;
}

function destroy() {
  blsWrapper = null;
}

function getContext() {
  if (blsWrapper) {
    return blsWrapper;
  }

  throw new Error("BLS not initialized");
}